<div *ngIf="!isLogged; else alreadyLoggedIn" class="container">
  <mat-card class="login">
    <mat-card-content>
      <div fxLayout="column"
           fxLayoutAlign="space-between center"
           fxLayoutGap="20px">
        <mat-icon>lock</mat-icon>
        <p i18n="@@login-title">Tu es sur l'interface d'administration de <b>Blinding</b> pour <b>piloter</b> ton blind-test.</p>
        <button mat-raised-button (click)="loginFb()" id="fb" i18n="@@login-fb">Connecter via Facebook</button>
        <button mat-raised-button (click)="loginGoogle()" id="google" i18n="@@login-google">Connecter via Google</button>
        <button mat-raised-button routerLink="../login-email" id="email" i18n="@@login-email">Avec ton Email</button>
      </div>
    </mat-card-content>
    <mat-card-footer>
      <span i18n="@@login-wishToHaveAnAccount"> Tu souhaites avoir un compte ?</span>
      <br/>
      <span i18n="@@login-contactUs" >Contacte-nous :</span>
      <br/>
      <span i18n="@@login-contactEmail">contact@leblindtest.fr</span>
    </mat-card-footer>
  </mat-card>
</div>

<ng-template #alreadyLoggedIn>
  <div class="container">
    <mat-card class="login">
      <mat-card-content>
        <div fxLayout="column"
             fxLayoutAlign="space-between center"
             fxLayoutGap="20px">
          <h2 style="text-align:center" i18n="@@login-userConnected">Tu es déjà connecté(e) !</h2>
          <button mat-raised-button routerLink="/dashboard" i18n="@@login-wantToPlay">Je veux jouer!</button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
